import { PreferredLanguageItem } from '@/modules/members'

export function useLanguageModule () {
    const languages: PreferredLanguageItem[] = [
        { code: 'fi', name: 'Finnish' },
        { code: 'no', name: 'Norwegian' },
        { code: 'se', name: 'Swedish' },
        { code: 'dk', name: 'Danish' },
        { code: 'en', name: 'English' }
    ]
    const languageOptions = languages.map(lang => {
        return {
            value: lang.code,
            label: lang.name
        }
    })

    return {
        languageOptions
    }
}
